module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-100.8cda8a51.woff2";